// extracted by mini-css-extract-plugin
export var actionIcons = "styles-module__actionIcons___QjJ34";
export var edit = "styles-module__edit___XIB6t";
export var archive = "styles-module__archive___ylvMJ";